import React, { useState, useRef, useEffect } from 'react';
import { BsSearch } from 'react-icons/bs';
import { debounce } from 'lodash';

const UniversalSearch = ({ 
  onSearch, 
  placeholder = "Search across all fields...",
  debounceTime = 300 
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchRef = useRef();

  // Crear y actualizar la función debounced cuando cambian las dependencias
  useEffect(() => {
    debouncedSearchRef.current = debounce((term) => {
      onSearch(term);
    }, debounceTime);
    
    // Limpieza al desmontar el componente
    return () => {
      if (debouncedSearchRef.current) {
        debouncedSearchRef.current.cancel();
      }
    };
  }, [onSearch, debounceTime]);

  const handleSearchChange = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    if (debouncedSearchRef.current) {
      debouncedSearchRef.current(term);
    }
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    onSearch(searchTerm);
  };

  const clearSearch = () => {
    setSearchTerm('');
    onSearch('');
  };

  return (
    <form onSubmit={handleSearchSubmit} className="universal-search-container">
      <div className="form-group d-flex align-items-center flex-row-reverse position-relative">
        
        <input
          type="text" 
          className="form-control ps-2 bg-transparent border-0 shadow-none" 
          placeholder={placeholder}
          value={searchTerm}
          onChange={handleSearchChange}
        />
        <button type="submit" className="p-0 bg-transparent border-0">
                <span className="d-block material-symbols-outlined icon-lg">search</span>
            </button>
        
      </div>
    </form>
  );
};

export default UniversalSearch;